import appConfig from 'configs/app.config'
import { ADMIN, YUPIUSER } from 'constants/roles.constant'

// yupiuser: dueño de direcciones registradas/reclamadas desde yupimaps-front.
// Solo ve sus Direcciones Estandarizadas e Invoices; si además es admin,
// manda el rol admin.
export const isYupiUserOnly = (authority) =>
    Array.isArray(authority) && authority.includes(YUPIUSER) && !authority.includes(ADMIN)

export const YUPIUSER_ENTRY_PATH = '/app/api/locations'

// La bienvenida (authenticatedEntryPath) no está habilitada para yupiuser.
export const getEntryPath = (authority) =>
    isYupiUserOnly(authority) ? YUPIUSER_ENTRY_PATH : appConfig.authenticatedEntryPath
